import { useState, useEffect } from 'react';
import { publicAPI } from '@/lib/api';

export default function LegalPage({ type }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    publicAPI.getLegal(type).then(res => {
      setContent(res.data.content || '');
      document.title = type === 'impressum' ? 'Impressum | GB Sylt Mietwagen' : 'Datenschutz | GB Sylt Mietwagen';
    }).catch(() => {
      setContent('Inhalt konnte nicht geladen werden.');
    }).finally(() => setLoading(false));
  }, [type]);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0E518D]" />
      </div>
    );
  }

  return (
    <div data-testid={`legal-page-${type}`} className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-8 capitalize">
          {type === 'datenschutz' ? 'Datenschutzerklärung' : 'Impressum'}
        </h1>
        <div className="prose prose-slate max-w-none font-body">
          {content.split('\n').map((line, i) => (
            <p key={i} className={`${line.startsWith('#') || line === line.toUpperCase() && line.length > 3 ? 'font-semibold text-slate-900 mt-6' : 'text-slate-600'} leading-relaxed`}>
              {line}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}
